module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(model.shortDescription) additionalClasses.push('fullHeight');\n%>\n<div class=\"<%- additionalClasses.join(' '); %>\">\n<section class=\"top\">\n<%#- include('./description', { model: { shortDescription: model.shortDescription } }); %>\n<%- include('./keyData', { model: { content: model.keyData } }); %>\n<%- include('./pricing', { model: { rentalPrice: model.rentalPrice } }); %>\n</section>\n<section class=\"bottom\">\n<%- include('./contact', { model: { phone: model.phone, shortDescription: model.shortDescription, shortDescriptionHTML: model.shortDescriptionHTML, expose: model.expose } }); %>\n</section>\n</div>"
  , __filename = "components/templates/project/gallery/rightSideBar.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(model.shortDescription) additionalClasses.push('fullHeight');

    ; __line = 4
    ; __append("\n<div class=\"")
    ; __line = 5
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<section class=\"top\">\n")
    ; __line = 7
    ; __append("\n")
    ; __line = 8
    ; __append( include('./keyData', { model: { content: model.keyData } }) )
    ; __append("\n")
    ; __line = 9
    ; __append( include('./pricing', { model: { rentalPrice: model.rentalPrice } }) )
    ; __append("\n</section>\n<section class=\"bottom\">\n")
    ; __line = 12
    ; __append( include('./contact', { model: { phone: model.phone, shortDescription: model.shortDescription, shortDescriptionHTML: model.shortDescriptionHTML, expose: model.expose } }) )
    ; __append("\n</section>\n</div>")
    ; __line = 14
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/gallery/rightSideBar.ejs

}